export enum RenderTypes {
  LINE = "line",
  TEXT = "text",
  FIELD_LIST_LINE = "field-list-line",
  FIELD_ARRAY_LIST = "field-array-list",
  MULTIPLE_VALUES_SEARCH = "multiple-values-search",
}
